import { CSSProperties } from 'react';
import { ApiMethod } from './api';
import { InteractiveList } from './list-message';
import { TemplateComponentFormat, TemplateComponentsArray } from './template';
import { ZohoStepComponent } from './zoho';
import { HelpData } from '.';

export enum ElementTypes {
  CLEARABLE_INPUT = 'CLEARABLE_INPUT',
  DELETABLE_INPUT = 'DELETABLE_INPUT',
  TEXTAREA = 'TEXTAREA',
  DROPDOWN = 'DROPDOWN',
  BUTTON_REPEAT = 'BUTTON_REPEAT',
  BUTTON_TEXT_ICON = 'BUTTON_TEXT_ICON',
  VARIABLE_REPLACE_INPUT = 'VARIABLE_REPLACE_INPUT',
  DELETABLE_BUTTON = 'DELETABLE_BUTTON',
  TEMPLATE_SELECTOR = 'TEMPLATE_SELECTOR',
  API_SELECTOR = 'API_SELECTOR',
  REFERENCE_BUTTON = 'REFERENCE_BUTTON',
  SELECTED_BUTTON = 'SELECTED_BUTTON',
  MEDIA_INPUT = 'MEDIA_INPUT',
  INPUT = 'INPUT',
  BUTTON = 'BUTTON',
  WEBHOOK_SELECTOR = 'WEBHOOK_SELECTOR',
  CHECKBOX = 'CHECKBOX',
  INTERACTIVE_LIST = 'INTERACTIVE_LIST',
  TIMER = 'TIMER',
  DATETIME_INPUT = 'DATETIME_INPUT',
  MULTI_SELECT_DROPDOWN = 'MULTI_SELECT_DROPDOWN',
  DROPDOWN_VARIABLE_INPUT= 'DROPDOWN_VARIABLE_INPUT',
  GOOGLE_SHEETS = 'GOOGLE_SHEETS',
  GOOGLE_SHEETS_API = 'GOOGLE_SHEETS_API',
  ZOHO = 'ZOHO',
  LABEL = 'LABEL',
  INTEGRATION_SELECTOR = 'INTEGRATION_SELECTOR',
  DATETIME_SCHEDULER = 'DATETIME_SCHEDULER',
  FACEBOOK_CONVERSION_API = 'FACEBOOK_CONVERSION_API',
  FACEBOOK_CONVERSION_EVENT = 'FACEBOOK_CONVERSION_EVENT',
  LEAD_FROM_CTWA_V2 = 'LEAD_FROM_CTWA_V2',
  TEXT_MEDIA_INPUT = 'TEXT_MEDIA_INPUT',
  ADD_TO_BROADCAST_LIST = 'ADD_TO_BROADCAST_LIST',
  WORKING_HOURS = 'WORKING_HOURS',
  CREATE_ZOHO_TICKET = 'CREATE_ZOHO_TICKET',
  UPDATE_ZOHO_TICKET = 'UPDATE_ZOHO_TICKET',
  CLOSE_ZOHO_TICKET = 'CLOSE_ZOHO_TICKET',
  SUFFIXED_INPUT = 'SUFFIXED_INPUT',
  DEFAULT_VALUE_ELEMENT = 'DEFAULT_VALUE_ELEMENT',
}

export enum ParentElementTypes {
  LIST = 'LIST',
  TEMPLATE = 'TEMPLATE',
}

export interface WebhooksValue {
  webhookId?: string;
  webhookUrl?: string;
  data?: any;
  authKey?: string | null;
  phoneSelectorPath?: string;
  integrations?: IntegrationsType;
  integrationSelectorPath?: string;
}

export enum RuleKeys {
  API_URL = 'api_url',
  API_METHOD = 'api_method',
  ALIGN = 'align',
  TEST_API_URL = 'test_api_url',
  TEST_API_METHOD = 'test_api_method',
  ADD_API_URL = 'add_api_url',
  ADD_API_METHOD = 'add_api_method',
  MAX = 'max',
  MIN = 'min',
  REGEX = 'regex',
  CLICK = 'click',
  ICON = 'icon',
  ICON_CLICK = 'icon_click',
  PLACEHOLDER = 'placeholder',
  LABEL = 'label',
  TEXT = 'text',
  DROPDOWN_LIST = 'list',
  REQUIRED = 'required',
  MULTIPLE = 'multiple',
  ISCONNECTOR = 'is_connector',
  BACKGROUND = 'background',
  TARGET_ELEMENT = 'target_element',
  TARGET_PARENT = 'target_parent',
  TARGET_COMPONENT = 'target_component',
  TARGET_HIERARCHY = 'target_hierarchy',
  ON_KEY_PRESS = 'on_key_press',
  WHICH_KEY = 'which_key',
  DISABLE_RENDER = 'disable_render',
  TOGGLE_RENDER_FROM_MENU = 'toggle_render_from_menu',
  IS_RENDER_TOGGLED = 'is_render_toggled',
  MAX_SIZE = 'max_size',
  MEDIA_TYPES = 'media_type',
  DISABLE_CONNECTION = 'disable_connection',
  BUTTON_LABEL = 'button_label',
  MENU = 'menu',
  RENDER_ON_BLOCK_HOVER = 'render_on_block_hover',
  DEFAULT_VALUE = 'default_value',
  MAX_LENGTH = 'max_length',
  SHOW_CHARACTER_LIMIT = 'show_character_limit',
  VALUE = 'value',
  SHOW_VARIABLES = 'show_variables',
  CAPTURE_API_URL = 'capture_api_url',
  CAPTURE_API_METHOD = 'capture_api_method',
  CAPTURE_LABEL = 'capture_label',
  MAX_DAY = 'max_day',
  CAN_BE_VARIABLE = 'can_be_variable',
  CAN_BE_PRESENT_WITH = 'can_be_present_with',
  CAN_BE_PRESENT_WITH_LEAST_COUNT = 'can_be_present_with_least_count',
  SAMPLE_VALUE = 'sample_value',
  INPUT_TYPE = 'input_type',
  MAX_ITEMS = 'max_items',
  MAX_SECTIONS = 'max_sections',
  DISABLE_RENDER_INPUT = 'disable_render_input',
  OPTIONS = 'options',
  IS_RADIO = 'is_radio',
  IS_MULTIPLE = 'is_multiple',
  TEXT_ELEMENT = 'text_element',
  DROPDOWN_ELEMENT = 'dropdown_element',
  DROPDOWN_OPTIONS = 'dropdown_options',
  TARGET_VISIBLE_OPTIONS = 'target_visible_options',
  STYLES = 'styles',
  EMAIL = 'email',
  VIDEO_URL = 'video_url',
  API_SEND_INTEGRATIONS = 'api_send_integrations',
  IS_ON_NEW_ROW_TRIGGER = 'is_on_new_row_trigger',
  CHECKBOX_TYPE = 'checkbox_type',
  CHECKBOX_LABEL = 'checkbox_label',
  DISABLE_FORMATTING_CHARS = 'disable_formatting_chars',
  DISABLE_EMOJIS = 'disable_emojis',
  IS_BUTTON_FROM_CAROUSEL = 'is_button_from_carousel',
  HIDE_WEBHOOK_URL = 'hide_webhook_url',
  SEARCH_DISABLED = 'search_disabled',
  DISABLED = 'disabled',
  SUFFIX = 'suffix',
  SUB_TEXT = 'subText',
  DEFAULT_VALUE_CAMEL = 'defaultValue',
  TARGET_ELEMENT_IDS = 'target_element_ids',
  PREFILL = 'prefill',
  BLOCK_TYPE = 'blockType',
  VARIABLE_KEY = 'variableKey',
  ALLOW_MEDIA_URL = 'allowMediaUrl',
}

export enum RuleValues {
  DELETE_ELEMENT = 'delete_element',
  ADD_ELEMENT = 'add_element',
  DELETE_ICON = 'delete_icon',
  ADD_CONNECTION = 'add_connection',
  REMOVE_CONNECTION = 'remove_connection',
  ADD_ICON = 'add_icon',
  SELECT_MEDIA = 'select_media',
  ENTER_KEY = 'Enter',
  SHOW_VALUE = 'show_value',
}
export enum ComponentTypes {
  KEYWORD_TRIGGER = 'KEYWORD_TRIGGER',
  INTERACTIVE_MESSAGE = 'INTERACTIVE_MESSAGE',
  INTERACTIVE_MESSAGE_V2 = 'INTERACTIVE_MESSAGE_V2',
  INTERACTIVE_LIST_MESSAGE = 'INTERACTIVE_LIST_MESSSAGE',
  TEMPLATE_MESSAGE = 'TEMPLATE_MESSAGE',
  API_CALL = 'API_CALL',
  WAIT_TILL = 'WAIT_TILL',
  WEBHOOK_TRIGGER = 'WEBHOOK_TRIGGER',
}
export enum DATE_FORMAT_TYPES {
  EVERY_DAY = 'EVERY_DAY',
  EVERY_MONTH = 'EVERY_MONTH',
  EVERY_WEEK = 'EVERY_WEEK',
  EVERY_YEAR = 'EVERY_YEAR',
  LAST_DAY_OF_MONTH = 'LAST_DAY_OF_MONTH',
}

export enum TriggerTypes {
  ON_INCOMING_CALL='ON_INCOMING_CALL',
  RECEIVE_MESSAGE = 'RECEIVE_MESSAGE',
  RECEIVE_WEBHOOK = 'RECEIVE_WEBHOOK',
  TIME_DELAY = 'TIME_DELAY',
  EVENT = 'EVENT',
  AGENT_ASSIGN = 'AGENT_ASSIGN',
  ASSIGN_AGENT_V2 = 'ASSIGN_AGENT_V2',
  ASSIGN_AGENT_V3 = 'ASSIGN_AGENT_V3',
  NEW_LEAD = 'NEW_LEAD',
  ATTRIBUTE_CHANGE = 'ATTRIBUTE_CHANGE',
  SALESFORCE_LEAD_UPDATED = 'SALESFORCE_LEAD_UPDATED',
  SALESFORCE_LEAD_CREATED = 'SALESFORCE_LEAD_CREATED',
  TEMPLATE_SENT = 'TEMPLATE_SENT',
  CLOSE_CONVERSATION = 'CLOSE_CONVERSATION',
  ON_NEW_ROW_GOOGLE_SHEET = 'ON_NEW_ROW_GOOGLE_SHEET',
  CALL_TO_WHATSAPP_MESSAGE_RECEIVED = 'CALL_TO_WHATSAPP_MESSAGE_RECEIVED',
  ON_TAGS_CHANGED = 'ON_TAGS_CHANGED',
  CONVERSATION_OPENED = 'CONVERSATION_OPENED',
  TALLY = 'TALLY',
  WOOCOMMERCE = 'WOOCOMMERCE',
  AI_BOT_INTENT_FILTER_TRIGGER = 'AI_BOT_INTENT_FILTER_TRIGGER',
  LEAD_FROM_CTWA_V2 = 'LEAD_FROM_CTWA_V2',
  ON_SLA_ESCALATION = 'ON_SLA_ESCALATION',
}

export enum ActionTypes {
  CALL_RING = 'CALL_RING',
  AI_BOT_GENERATE_RESPONSE = 'AI_BOT_GENERATE_RESPONSE',
  SEND_MESSAGE = 'SEND_MESSAGE',
  SEND_TEMPLATE = 'SEND_TEMPLATE',
  SEND_INTERACTIVE_MESSAGE = 'SEND_INTERACTIVE_MESSAGE',
  SEND_INTERACTIVE_MESSAGE_V2 = 'SEND_INTERACTIVE_MESSAGE_V2',
  ASSIGN_AGENT = 'ASSIGN_AGENT',
  ASSIGN_AGENT_V2 = 'ASSIGN_AGENT_V2',
  ASSIGN_AGENT_V3 = 'ASSIGN_AGENT_V3',
  API_CALL = 'CALL_API',
  SET_ATTRIBUTE = 'SET_ATTRIBUTE',
  UPDATE_ATTRIBUTE = 'UPDATE_ATTRIBUTE',
  CONDITIONAL = 'CONDITIONAL',
  TIME_DELAY = 'TIME_DELAY',
  WAIT_TILL = 'WAIT_TILL',
  SEND_INTERACTIVE_LIST_MESSAGE = 'SEND_INTERACTIVE_LIST_MESSAGE',
  GOOGLE_SHEETS = 'GOOGLE_SHEETS',
  SET_TAGS = 'SET_TAGS',
  UPDATE_TAG = 'UPDATE_TAG',
  SEND_CATALOGUE = 'SEND_CATALOGUE',
  ZOHO = 'ZOHO',
  CLOSE_CONVERSATION = 'CLOSE_CONVERSATION',
  OPT_OUT = 'OPT_OUT',
  FORMAT_DATE = 'FORMAT_DATE',
  FORMAT_PHONE = 'FORMAT_PHONE',
  FACEBOOK_CONVERSION_API = 'FACEBOOK_CONVERSION_API',
  FACEBOOK_CONVERSION_EVENT = 'FACEBOOK_CONVERSION_EVENT',
  ADD_TO_BROADCAST_LIST = 'ADD_TO_BROADCAST_LIST',
  WORKING_HOURS = 'WORKING_HOURS',
  AI_BOT_SEND_TOOL_CALL_RESPONSE = 'AI_BOT_SEND_TOOL_CALL_RESPONSE',
  CREATE_ZOHO_TICKET = 'CREATE_ZOHO_TICKET',
  UPDATE_ZOHO_TICKET = 'UPDATE_ZOHO_TICKET',
  CLOSE_ZOHO_TICKET = 'CLOSE_ZOHO_TICKET',
  ON_SLA_BREACHED = 'ON_SLA_BREACHED',
  SEND_LOCATION = 'SEND_LOCATION'
}

export interface Integration {
  id: string;
  name: string;
  phone: string;
  dtHandle?: string;
}

export interface AppData {
  appBotBuilder: AppBotBuilder;
  httpHeaders: string[];
  httpMethods: ApiMethod[];
  globalVariables: ComponentVariables;
  globalVariablesV2: ComponentVariables;
  dualConnectors: string[];
  integrations: Integration[];
  startingNodes: APINodeData[];
  variables?: {
    globals: GlobalVariable[];
  };
}

export interface AppBotBuilder {
  triggers: Block[];
  actions: Block[];
}

export type Block = {
  blockId: string;
  blockName: string;
  blockType: ActionTypes | TriggerTypes;
  components: Array<Component>;
  blockDescription: string;
  shortDescription: string;
  blockDataType: BlockDataType;
  isStartNode: boolean;
  needsProcessing: boolean;
  blockIsEmpty?: boolean;
  isVisible?: boolean;
  integrationIds?: IntegrationsType;
  disableIntegration?: boolean;
  helpData?: HelpData;
  blockGroup?: string;
  groupLabel?: string;
  groupColor?: string;
  groupIsIntegration?: boolean;
  groupVisibilityKey?: string | null;
  groupOrder?: number;
};

export enum BlockDataType {
  ACTION = 'action',
  TRIGGER = 'trigger',
}

export type ComponentVariable = {
  id: string | number;
  key: string;
  value: string;
  keepValue?: boolean;
};

export type ComponentVariables = ComponentVariable[];

export interface Component {
  componentId: string;
  componentName: string;
  componentIsMultiple: boolean;
  componentPosition: number;
  componentVariables: ComponentVariables | null;
  componentVariablesV2: ComponentVariables | null;
  componentType: ComponentTypes;
  elements: Elements[];
}

export enum globalVariableType {
  TIME = 'TIME',
}

export enum VariableValueType {
  SELECTOR = 'SELECTOR',
  VALUE = 'VALUE',
}

export type GlobalVariable = GlobalVariableSelector | GlobalVariableValue;

export type GlobalVariableSelector = {
  key: globalVariableType | string;
  name: string;
  type: VariableValueType.SELECTOR;
  variables: Array<GlobalVariable>;
};

export type GlobalVariableValue = {
  key: globalVariableType | string;
  name: string;
  id: string;
  type: VariableValueType.VALUE;
  value: string;
  params?: Array<{
    type: string;
    name: string;
    optional: boolean;
  }>;
};

export type ComponentVariables_ = {
  [key: string]: ComponentVariables;
};

export enum RuleOuterKeys {
  META = 'meta',
  TYPE = 'type',
}

export interface Rules {
  [RuleKeys.API_URL]?: string;
  [RuleKeys.ALIGN]?: string;
  [RuleKeys.CAPTURE_API_URL]?: string;
  [RuleKeys.API_METHOD]?: string;
  [RuleKeys.CAPTURE_API_METHOD]?: string;
  [RuleKeys.CAPTURE_LABEL]?: string;
  [RuleKeys.MAX]?: number;
  [RuleKeys.MIN]?: number;
  [RuleKeys.REGEX]?: string;
  [RuleKeys.CLICK]?: RuleValues;
  [RuleKeys.ICON]?: string;
  [RuleKeys.ICON_CLICK]?: RuleValues;
  [RuleKeys.PLACEHOLDER]?: string;
  [RuleKeys.LABEL]?: string;
  [RuleKeys.LABEL]?: string;
  [RuleKeys.TEXT]?: string;
  [RuleKeys.REQUIRED]?: boolean;
  [RuleKeys.MULTIPLE]?: boolean;
  [RuleKeys.ISCONNECTOR]?: boolean;
  [RuleKeys.BACKGROUND]?: string;
  [RuleKeys.TARGET_ELEMENT]?: string;
  [RuleKeys.TARGET_PARENT]?: string;
  [RuleKeys.TARGET_COMPONENT]?: string;
  [RuleKeys.TARGET_HIERARCHY]?: string;
  [RuleKeys.ON_KEY_PRESS]?: RuleValues;
  [RuleKeys.WHICH_KEY]?: string;
  [RuleKeys.DISABLE_RENDER]?: boolean;
  [RuleKeys.TOGGLE_RENDER_FROM_MENU]?: boolean;
  [RuleKeys.IS_RENDER_TOGGLED]?: boolean;
  [RuleKeys.VALUE]?: string | Record<string, any>;
  [RuleOuterKeys.META]?: RuleMeta;
  [RuleOuterKeys.TYPE]?: RuleTypes;
  [RuleKeys.MAX_SIZE]?: number;
  [RuleKeys.MEDIA_TYPES]?: string;
  [RuleKeys.DISABLE_CONNECTION]?: boolean;
  [RuleKeys.BUTTON_LABEL]?: string;
  [RuleKeys.MENU]?: string;
  [RuleKeys.RENDER_ON_BLOCK_HOVER]?: boolean;
  [RuleKeys.DEFAULT_VALUE]?: string;
  [RuleKeys.MAX_LENGTH]?: number;
  [RuleKeys.SHOW_CHARACTER_LIMIT]?: boolean;
  [RuleKeys.SHOW_VARIABLES]?: boolean;
  [RuleKeys.MAX_DAY]?: number;
  [RuleKeys.CAN_BE_VARIABLE]?: boolean;
  [RuleKeys.CAN_BE_PRESENT_WITH]?: ElementTypes[];
  [RuleKeys.CAN_BE_PRESENT_WITH_LEAST_COUNT]?: number;
  [RuleKeys.SAMPLE_VALUE]?: InteractiveList;
  [RuleKeys.INPUT_TYPE]?:
    | React.InputHTMLAttributes<unknown>['type']
    | 'datetime';
  [RuleKeys.MAX_ITEMS]?: number;
  [RuleKeys.MAX_SECTIONS]?: number;
  [RuleKeys.DISABLE_RENDER_INPUT]?: boolean;
  [RuleKeys.OPTIONS]?: { value: string; label: string }[];
  [RuleKeys.IS_RADIO]?: boolean;
  [RuleKeys.IS_MULTIPLE]?: boolean;
  [RuleKeys.DROPDOWN_ELEMENT]?: string;
  [RuleKeys.TEXT_ELEMENT]?: string;
  [RuleKeys.DROPDOWN_OPTIONS]?: DropdownData[];
  [RuleKeys.DROPDOWN_LIST]?: DropDownListItem[];
  [RuleKeys.TARGET_VISIBLE_OPTIONS]?: string[];
  [RuleKeys.STYLES]?: CSSProperties;
  [RuleKeys.EMAIL]?: string;
  [RuleKeys.VIDEO_URL]?: string;
  [RuleKeys.API_SEND_INTEGRATIONS]?: boolean;
  [RuleKeys.IS_ON_NEW_ROW_TRIGGER]?: boolean;
  [RuleKeys.CHECKBOX_TYPE]?: string;
  [RuleKeys.CHECKBOX_LABEL]?: string;
  [RuleKeys.DISABLE_FORMATTING_CHARS]?: boolean;
  [RuleKeys.DISABLE_EMOJIS]?: boolean;
  [RuleKeys.IS_BUTTON_FROM_CAROUSEL]?: boolean;
  [RuleKeys.HIDE_WEBHOOK_URL]?: boolean;
  [RuleKeys.SEARCH_DISABLED]?: boolean;
  [RuleKeys.DISABLED]?: boolean;
  [RuleKeys.SUFFIX]?: string;
  [RuleKeys.SUB_TEXT]?: string;
  [RuleKeys.DEFAULT_VALUE_CAMEL]?: string | number;
  [RuleKeys.TARGET_ELEMENT_IDS]?: string[];
  [RuleKeys.PREFILL]?: boolean;
  [RuleKeys.BLOCK_TYPE]?: ActionTypes | TriggerTypes | string;
  [RuleKeys.VARIABLE_KEY]?: string;
  [RuleKeys.ALLOW_MEDIA_URL]?: boolean;
}
export interface DropDownListItem {
  label: string;
  value: string;
}

export interface RuleMeta {
  copyable?: boolean;
  deletable?: boolean;
  label?: string;
  editable?: boolean;
}

export enum RuleTypes {
  ApiData = 'API_DATA',
}

export type Element = {
  elementId: string;
  elementType: ElementTypes | ParentElementTypes;
  elementName: string;
  elementPosition: number;
  elementRules: Rules;
  elementIsMandatory: boolean;
  uniqueId: string;
  value?: Values;
};

export type MultiCheckboxValue = {
  value: string;
  label: string;
}[];

export type ZohoValue = {
  accountId: string;
  components: ZohoStepComponent;
};

export type CreateZohoDeskTicketValue = {
  accountId: string | null;
  departmentId: string;
  title: string;
  description: string;
};

export type UpdateZohoDeskTicketValue = {
  accountId: string | null;
  ticketId: string;
  comment: string;
};

export type CloseZohoDeskTicketValue = {
  accountId: string | null;
  ticketId: string;
};

export interface SchedulerData {
  id: string;
  daysBefore: number;
  hoursBefore: number;
  minutesBefore: number;
  atSpecificTime: boolean;
  time: string;
  timezone: string;
}

export type DateTimeSchedulerValue = {
  [k: string]: SchedulerData;
};

export type AddToBroadcastListValue = {
  groupIds: string[];
};

export type UpdateAttributeValue = {
  fieldName: string;
  fieldValue?: string;
}[];


export type PartialMatchTextValue = {
  text: string;
  partiallyMatch: boolean;
};

export type Values =
  | string
  | boolean
  | string[]
  | TemplateSelectorValue
  | WebhooksValue
  | MediaValue
  | ApiSelectorValue
  | InteractiveList
  | MultiCheckboxValue
  | GoogleSheetValue
  | GoogleSheetValueV2
  | FacebookCAPIValue
  | FacebookCAPIEventValue
  | ZohoValue
  | CreateZohoDeskTicketValue
  | UpdateZohoDeskTicketValue
  | CloseZohoDeskTicketValue
  | DateTimeSchedulerValue
  | PartialMatchTextValue
  | LeadCTWA2Types
  | AddToBroadcastListValue
  | UpdateAttributeValue
  | undefined
  | null;

export interface GoogleSheetValue {
  spreadsheetId: string;
  sheetName: string;
  accountId: string;
  useFirstRowAsHeader?: boolean;
  phoneSelector?: string;
  integrationSelector?: string;
  value: (string | null)[];
  gId: number;
}
export interface FacebookCAPIValue {
  accountId: string;
  adSourceId: string | null;
  pageId: string | null;
  pixelId: string | null;
  eventName: string | null;
  eventTime: string | number | null;
  ctwaClid: string;
  customData?: {
    currency: string;
    value: string;
  };
  value: (string | null)[];
}
export interface FacebookCAPIEventValue {
  accountId: string;
  eventName: string | null;
  eventTime: string | number | null;
  customData?: {
    currency: string;
    value: string;
  };
}
export enum LeadCTWA2LevelTypes {
  ALL = 'all',
  CAMPAIGN = 'campaign',
  ADSET = 'adset',
  AD = 'ad',
}
export interface LeadCTWA2Types {
  targetLevel: LeadCTWA2LevelTypes;
  accountId: string;
  targetId: string;
  name: string;
}
export interface GoogleSheetValueV2 {
  sheetUrl: string;
  sheetName: string;
  value: (string | null)[];
}

export interface MediaValue {
  mediaType: string;
  mediaUrl: string;
  fileName: string;
}

export type TemplateHeaderValueFormat =
  | {
      type: TemplateComponentFormat.TEXT;
      placeholder: string;
    }
  | {
      type: TemplateComponentFormat.IMAGE | TemplateComponentFormat.VIDEO;
      mediaUrl: string;
      isDeleted?: boolean;
    }
  | {
      type: TemplateComponentFormat.DOCUMENT;
      mediaUrl: string;
      filename: string;
      isDeleted?: boolean;
    };

export type BaseTemplateData = {
  header?: TemplateHeaderValueFormat;
  body?: {
    placeholders?: (string | null)[];
  };
  buttons?: Array<{
    type: string;
    parameter: string;
  }>;
};

export type TemplateData = BaseTemplateData & {
  cards?: Array<{
    cardIndex: number;
    components: BaseTemplateData;
  }>;
};

export interface TemplateSelectorValue {
  templateId: number;
  templateName: string;
  templateLanguage: string;
  templateComponent: TemplateComponentsArray;
  templateData: TemplateData | null;
}

export interface ApiDataFile {
  url: string;
  file: {
    size: number;
    encoding: string;
    mimetype: string;
    fieldname: string;
    originalname: string;
  };
}

export type ApiBody = Array<
  {
    key: string;
  } & (
    | {
        value: string;
        type: 'string' | 'number' | 'boolean';
      }
    | {
        value: {
          type: 'FLOW_API_CALL_FILE';
          files: Array<ApiDataFile>;
        };
        type: 'FLOW_API_CALL_FILE';
      }
  )
>;

export interface ApiData {
  apiId: number;
  headers: { key: string; value: string }[];
  params: { key: string; value: string }[];
  pathParams: { key: string; value: string }[];
  body: ApiBody;
}

export interface ApiSelectorValue extends ApiData {}

export interface SingleElement extends Element {
  hasChildren: false;
}

export interface MultipleElement extends Element {
  hasChildren: true;
  childElements: Array<SingleElement>;
}

export type Elements = SingleElement | MultipleElement;

export interface DefaultValueElementRules {
  default_value?: unknown;
  prefill?: boolean;
  blockType?: ActionTypes | TriggerTypes | string;
  variableKey?: string;
}

export type DefaultValueElementType = {
  elementType: ElementTypes | ParentElementTypes;
  elementRules: DefaultValueElementRules;
};

export type NodeData = Block & {};

export type APINodeData = NodeData & {
  nodeId: string;
  position: { x: number; y: number };
  dimension?: { width: number; height: number };
};

export enum WebhooksTriggerStatus {
  DRAFT = 'draft',
  SAVED = 'saved',
  CLEANED = 'cleaned',
}

export interface WebhooksTrigger {
  id: string;
  status: WebhooksTriggerStatus;
  url: string;
  data?: string;
  authKey?: string | null;
  botComponentId: string;
  appId: string;
  botId: string;
  triggerId: string;
  dateCreated: Date;
  dateUpdated: Date;
}

export type ProcessBlockResponse = WebhooksTrigger;

export type DropdownData = {
  label: string;
  value: string;
  binary?: boolean;
  dropdownValue?: DropdownData[];
  icon?: string;
  subLabel?: string;
  buttons?: { label: string; value: string }[];
};

export enum IntegrationType {
  ALL_INTEGRATIONS = 'ALL_INTEGRATIONS',
  PREVIOUS_INTEGRATION = 'PREVIOUS_INTEGRATION',
}

export type IntegrationsType = string[] | IntegrationType;

export interface TimeZone {
  label: string;
  value: string;
}
